import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import logo from 'Resources/Images/kansas-logo.jpg';
import TextField from 'Common/TextField/TextFieldWithError';
import Button from 'Common/Button';
import { createStyles, Theme } from '@material-ui/core';

const styles = (theme: Theme) => createStyles({
    container: {
    },
    errors: {
        color: "#F44336",
        margin: `${theme.spacing(1)}px auto`
    },
    image: {
    },
    buttonContainer: {

    }
});

interface LoginFormAttributes {
    classes: any;
    username: string;
    password: string;
    onChange: any;
    onKeyPress(event: React.KeyboardEvent): void;
    clearError: any;
    onLogin: (event: React.MouseEvent) => void;
    error: any;
}

const LoginForm = (props: LoginFormAttributes) => {

    const { classes, username, password, onChange, onKeyPress, clearError, onLogin, error } = props;

    return (
        <div className={classes.container}>
            <div>
                <img className={classes.image} src={logo} alt="New England Compass Logo" />
            </div>
            <div>
                {
                    error &&
                    <div className={classes.errors}>
                        {error}
                    </div>
                }
                <TextField
                    disabled={false}
                    label="User Name"
                    name="username"
                    value={username}
                    handleChange={onChange} />
                <br />
                <TextField
                    disabled={false}
                    label="Password"
                    name="password"
                    value={password}
                    handleChange={onChange}
                    onKeyPress={onKeyPress}
                    type="password" />
            </div>
            <div className={classes.buttonContainer}>
                <Button
                    onClick={onLogin}
                    variant="outlined"
                >
                    Login
                </Button>
            </div>
        </div>
    );
}

export default withStyles(styles)(LoginForm);